import { render, staticRenderFns } from "./salesBelowCostList.vue?vue&type=template&id=5a38233e"
import script from "./salesBelowCostList.vue?vue&type=script&lang=js"
export * from "./salesBelowCostList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports